/**
* Created by vouill on 8/18/18.
*/

<template>
  <div class="v-content-container">
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'evenement', include: 3, order:orderField, [filterField]: now }"
      :key-path="['evenements']"
    />
    <event-title/>
    <hoc
      :key-path="['websiteMeta']"
    >
      <template slot="success"><event-intro /></template>
    </hoc>
    <div class="link-list">
      <router-link to="/evenements">Prochain événements</router-link>
      <router-link to="/evenements/past">Evénements passés</router-link>
    </div>
    <vuex-api-hoc
      :key-path="['evenements']"
    >
      <template slot="success"><event-list/></template>
    </vuex-api-hoc>
  </div>
</template>

<style scoped lang="scss">
.link-list {
  margin-bottom: 1em;
}
.link-list a {
  margin-right: 1em;
}
.router-link-exact-active {
  color: darken(#00cbef, 10%);
}
</style>
<script>
import EventList from "./event-list";
import moment from "moment";
import EventTitle from "./event-title";
import EventIntro from "./EventIntro";
import { hoc } from "vuex-api";
export default {
  name: "Evenements",
  components: { EventList, EventIntro, EventTitle, hoc },
  computed: {
    filterField: function() {
      return this.$route.path.endsWith("past")
        ? "fields.dateStarted[lte]"
        : "fields.dateStarted[gte]";
    },
    orderField: function() {
      return this.$route.path.endsWith("past")
        ? "-fields.dateStarted"
        : 'fields.dateStarted';

    }
  },
  data() {
    return {
      now: moment().format()
    };
  }
};
</script>
